// extracted by mini-css-extract-plugin
export var infoItem = "_iu-1";
export var title = "_iu-0";